import { Textarea } from "@/modern/components/ui/textarea";
import { cn } from "@/modern/utils";
import {
  FILE_DETAIL_FIELD_CONTROL_CLS,
  FILE_DETAIL_FIELD_FOCUS_CLS,
  FILE_DETAIL_FIELD_LABEL_CLS,
} from "../../fileDetailFormClasses";

interface MarketingContentDescriptionProps {
  caption: string;
  altText: string;
  onCaptionChange: (value: string) => void;
  onAltTextChange: (value: string) => void;
  captionMaxLength?: number;
  captionError?: string;
  altTextError?: string;
  required?: boolean;
}

export const MarketingContentDescription = ({
  caption,
  altText,
  onCaptionChange,
  onAltTextChange,
  captionMaxLength,
  captionError,
  altTextError,
  required,
}: MarketingContentDescriptionProps) => {
  const showCaptionCount =
    captionMaxLength != null && caption.length > captionMaxLength * 0.75;

  return (
    <div className="space-y-5">
      <div>
        <label className={FILE_DETAIL_FIELD_LABEL_CLS}>
          Caption {required ? <span className="text-destructive">*</span> : null}
        </label>
        <Textarea
          value={caption}
          onChange={(e) => onCaptionChange(e.target.value)}
          rows={2}
          maxLength={captionMaxLength}
          className={cn(
            FILE_DETAIL_FIELD_CONTROL_CLS,
            FILE_DETAIL_FIELD_FOCUS_CLS,
            "min-h-[4.5rem] resize-y",
            captionError && "border-destructive focus-visible:ring-destructive",
          )}
          placeholder="Short caption for marketing…"
        />
        {showCaptionCount ? (
          <span
            className={cn(
              "mt-1 block text-right text-xs tabular-nums",
              captionMaxLength && caption.length > captionMaxLength * 0.9
                ? "text-amber-500"
                : "text-muted-foreground",
            )}
          >
            {caption.length}/{captionMaxLength}
          </span>
        ) : null}
        {captionError ? <p className="mt-1 text-sm text-destructive">{captionError}</p> : null}
      </div>

      <div>
        <label className={FILE_DETAIL_FIELD_LABEL_CLS}>
          Alt text {required ? <span className="text-destructive">*</span> : null}
        </label>
        <Textarea
          value={altText}
          onChange={(e) => onAltTextChange(e.target.value)}
          rows={2}
          className={cn(
            FILE_DETAIL_FIELD_CONTROL_CLS,
            FILE_DETAIL_FIELD_FOCUS_CLS,
            "min-h-[4.5rem] resize-y",
            altTextError && "border-destructive focus-visible:ring-destructive",
          )}
          placeholder="Describe the image for accessibility…"
          aria-description="Used for accessibility and search indexing."
        />
        {altTextError ? <p className="mt-1 text-sm text-destructive">{altTextError}</p> : null}
      </div>
    </div>
  );
};
